import { getLocalDate } from "./init-config-date";
const isDateEqualOrLaterThanCurrent = dateString => {
  // Parse the input date string to extract month and year
  const [inputMonth, inputYear] = dateString.split("/").map(Number);
  // Get the current date
  const currentDate = new Date();
  const currentMonth = currentDate.getMonth() + 1; // Month is 0-indexed in JavaScript
  const currentYear = currentDate.getFullYear();
  // Check if the input date is equal to or later than the current month and year
  return inputYear > currentYear || (inputYear === currentYear && inputMonth >= currentMonth);
};
const formatMonthYear = dateString => {
  return getLocalDate(dateString, "MM/YYYY", true).isValid();
};
const validDate = dateString => {
  return getLocalDate(dateString, "DD/MM/YYYY", true).isValid();
};
const convertDateToRequest = (date, format = "DD/MM/YYYY") => {
  try {
    // console.log(!date, dayjs(date).format(format));
    if (!date) return "";
    if (typeof date === "string") {
      return getLocalDate(date, format).format(format);
    }
    return getLocalDate(date).format(format);
  } catch (error) {
    console.error(error);
  }
};
export { isDateEqualOrLaterThanCurrent, formatMonthYear, convertDateToRequest, validDate };
